module.exports = __webpack_public_path__ + "img/right-arrow.55d5989c.svg";